/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Legs1(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Legs1.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Legs1.geometry}
        position={[0.57, -32.83, 20.17]}
      >
        {' '}
        <meshPhysicalMaterial
          color={colorArr[5]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Legs1.glb')
